module.exports = __webpack_public_path__ + "img/arrow-left-modal.837ca0bb.svg";